import { PageController } from '@client/components/_core/layout/PageController';
import { Tabs } from '@client/components/_core/navigation/Tabs';
import type { ShareableRouteContext } from '@client/types/router';
import { createFileRoute } from '@tanstack/react-router';
import { FileSearch } from 'lucide-react';

export const Route = createFileRoute('/console/$orgId/tools/document-analyzer')({
    staticData: {
        breadcrumb: {
            title: 'Document analyser',
        },
        // Declared on the layout so the Upload and History pages carry the gate too.
        modules: ['document-analyzer'],
        permissions: ['document_analyzer:use'],
        ui: {
            icon: FileSearch,
        },
        presentation: 'fullPage',
    },

    beforeLoad(): ShareableRouteContext {
        return {
            ui: {
                title: 'Document analyser',
            },
        };
    },
    component: DocumentAnalyzer,
});

function DocumentAnalyzer() {
    return (
        <PageController route={Route}>
            <Tabs
                items={[
                    {
                        label: 'Upload',
                        to: '/console/$orgId/tools/document-analyzer/upload',
                    },
                    {
                        label: 'History',
                        to: '/console/$orgId/tools/document-analyzer/history',
                    },
                ]}
            />
        </PageController>
    );
}
